import { useSelector } from 'react-redux'
import { Navigate } from "react-router-dom";

const Login = prop => {
  const { isLoggedin } = useSelector(state => state.user);
  const fromUrl = (new URLSearchParams(window.location.search)).get("from");
  if(!isLoggedin && fromUrl) {
    localStorage.setItem('from', fromUrl);
  }
  if(!isLoggedin && !fromUrl) {
    localStorage.removeItem('from');
  }
  if(isLoggedin) {
    const from = localStorage.getItem('from');
    if(from) return <Navigate to={from}  replace={true} />
  }
  return (
    <div className="u-container u-margin-top-3xl u-margin-bottom-lg" role="main">
      <h2 className="u-margin-top u-margin-bottom">Je bent niet aangemeld</h2>
      <a href="/auth/login/mprofiel" className="a-button u-margin-top">Aanmelden</a>
    </div>
  );
};

export default Login;
